import { CONTEXT_ATTRIBUTES, WEB_ATTRIBUTES } from '@/model/algolia/constants';
import {
  GameFromAlgolia,
  modernLauncherUrlParamsType,
} from '@/model/algolia/types';

const removeFalsyValuesFromUrlObject = (
  params: modernLauncherUrlParamsType
) => {
  const urlParams = new URLSearchParams();
  Object.keys(params).forEach((key: string) => {
    const param = params[key as keyof modernLauncherUrlParamsType];
    if (param) {
      const mappedKey = WEB_ATTRIBUTES.includes(key) ? `web.${key}` : key;
      const paramKey = CONTEXT_ATTRIBUTES.includes(key)
        ? `context[${mappedKey}]`
        : mappedKey;

      urlParams.append(paramKey, param);
    }
  });
  return urlParams.toString();
};

export function createLaunchUrl(
  game: GameFromAlgolia,
  locale?: string,
  game_launch_placement?: string
): string {
  const urlParams: modernLauncherUrlParamsType = {
    language: locale,
    locale,
    game_launch_placement,
  };

  return `/launch/${game.presentation_code}?${removeFalsyValuesFromUrlObject(
    urlParams
  )}`;
}
